import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col space-y-8 items-center" }
const _hoisted_2 = {
  key: 0,
  class: "w-full mt-16 flex flex-col space-y-4 items-center"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "text-2xl align-middle" }, "Page Not Found", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "text-lg text-gray-500 text-center w-10/12 sm:w-1/2" }, " We are unable to find what you are looking for ", -1)
const _hoisted_5 = {
  key: 1,
  class: "w-full mt-16 flex flex-col space-y-4 items-center"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "text-2xl text-center" }, "Access Denied", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "text-lg text-gray-500 text-center w-10/12 sm:w-1/2" }, " You do not have the permission to access this page ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseIcon = _resolveComponent("BaseIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isError404)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_BaseIcon, {
            name: "warning",
            iconClass: "w-12 h-12 text-yellow-600 fill-current"
          }),
          _hoisted_3,
          _hoisted_4
        ]))
      : _createCommentVNode("", true),
    (_ctx.isError403)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createVNode(_component_BaseIcon, {
            name: "lock",
            iconClass: "w-12 h-12 text-yellow-600 fill-current"
          }),
          _hoisted_6,
          _hoisted_7
        ]))
      : _createCommentVNode("", true)
  ]))
}